import Vue from 'vue'
// import Utils from '../tools/utils.js'
import Vuex from 'vuex'

Vue.use(Vuex)
const options = new Vuex.Store({
  // 多页面共享数据
  state: {
    // 页面过渡loading
    isLoading: false,
    // 用户信息
    userId: '12559191692',
    user: {},
    role: [],
    productName: '',
    token: '',
    userInfo: '',
    // 全局信息提示
    globalAlertStatus: false,
    globalAlertText: '',
    // 头部全局配置
    leftOptions: {},
    title: '',
    direction: 'forward',
    clickBack: function () {
      console.log(232)
    }
  },

  // 数据变更
  mutations: {
    updateLoadingStatus (state, data) {
      state.isLoading = data.isLoading
    },
    setRole (state, data) {
      state.role = data
    },
    setProductName (state, data) {
      state.productName = data
    },
    setGlobalAlertStatus (state, data) {
      state.globalAlertStatus = data
    },
    setGlobalAlertText (state, data) {
      state.globalAlertText = data
    },
    setLeftOptions (state, data) {
      state.leftOptions = data
    },
    setTitle (state, data) {
      state.title = data
    },
    setUserInfo (state, data) {
      state.userInfo = data
    },
    setClickBack (state, data) {
      state.clickBack = data
    }
  },

  // 操作
  actions: {},

  // 获取数据
  getters: {
    getFullScreenSLoading (state) {
      return state.fullScreenSLoading
    },
    getUserId (state) {
      return state.userId
    },
    getGlobalAlertStatus (state) {
      return state.globalAlertStatus
    },
    getGlobalAlertText (state) {
      return state.getGlobalAlertText
    }
  }
})

export default options



// WEBPACK FOOTER //
// ./src/vuex/store.js